import { FormikFunction } from "../../../components/post_editor/SidePanel/formik-function/formik-function";
import Tiptap from "../../../components/post_editor/TiptapFunc";
import { useProject } from "../../../contexts/projectContext";
import "./index.css";

const Editor = ({ blogPost }) => {
  const { open: exportOpen, setOpen: setExportOpen } = useProject();

  return (
    <>
      <FormikFunction blogPost={blogPost}>
        <Tiptap />
      </FormikFunction>
      {/* <ExportModal open={exportOpen} setOpen={setExportOpen} /> */}
    </>
  );
};

export default Editor;
